/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/9/18
 * Time: 19:44
 * Desc: 营销中心-秒杀活动-新增/编辑
 */
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import type { ElForm } from 'element-ui/types/form';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import { IPSService } from '@/services/ipsServices';
import IPSDatePicker from '@/views/components/ips-date-picker';
import Sketch from '@/views/components/sketch';
import ProductItem from '@/views/components/productItem/productItem.vue';
import Upload from '@/views/components/upload/upload.vue';
import { noop } from '@/util';
import selectGoods from '@/views/components/selectGoods';
import ImgPreview from '@/views/components/imgPreview';
import validateParams from '@/library/utils/paramFilter';
import baseAPIService from '@/services/base/baseAPIService';
import { Functions } from '@/library/utils/functions';
import NewSelectSite from '@/views/components/newSelectSIte';

@Component({
  components: {
    IPSDatePicker,
    Sketch,
    ProductItem,
    Upload,
  },
})
export default class SeckillOrderDetail extends Vue {
  //  预览组件的参数

  componentKeys = ['group', 'shareCard', 'sharePoster'];

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();
  platformVersion: number;

  get componentData() {
    return [
      {
        ...this.seckillForm._list[0],
        ...{ groupNum: this.seckillForm.groupNum, productImages: this.seckillForm.productImages },
      },
      { img: this.seckillForm.shareCardPicture, title: this.seckillForm.ptName },
      { img: this.seckillForm.sharePicture, title: this.seckillForm.ptName },
    ];
  }

  // 是版单号还是商品货号 1: 货号 ，2: 版单号
  selectGoodsType = 1;

  $refs: {
    form: ElForm;
  };

  /**
   * 秒杀活动Id
   * @type {number}
   */
  @Prop({ default: 0 }) ptId: number;

  /**
   * 图片放大弹窗是否显示
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * 最终的网点列表
   * @type {number}
   */
  public finalSiteList: Array<any> = [];

  /**
   * 预览二维码
   */
  public imageView = '';

  /**
   * 是否展示预览二维码
   */
  public isShowCode = false;

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  // 默认是开启的状态
  public state = 1;
  // 默认是未开始
  public activityState = 1;
  public updatePersonCode = '';
  /**
   * 当前添加图片的富文本
   * @type {null}
   */
  public addRang: any = {};

  // 权限 1 有 0 没有
  public operAuthority = 1;

  get isEdit() {
    const empCode = localStorage.getItem('empCode') || '';
    // empCode != scope.row.updatePersonCode && scope.row.updatePersonCode !==""
    if (this.state === 0) {
      return true;
    }
    return this.activityState !== 1 || !this.operAuthority;
  }

  get editStockState() {
    const empCode = localStorage.getItem('empCode') || '';
    if (this.state === 0) {
      return true;
    }
    return (this.activityState !== 1 && this.activityState !== 2 && this.activityState !== 4) || !this.operAuthority;
  }

  /**
   * 添加活动列表
   * @type {ItemObject}
   */
  public seckillForm: ItemObject = {
    ptId: 0, // 商品ID
    ptName: '', // 活动名称
    productOriginPrice: '', // 商品牌价
    actBeginTime: '', // 活动开始时间
    actEndTime: '', // 活动结束时间
    qikanImage: undefined, // 期刊显示的图片，如不传，就不在期刊页面展示。如取消展示，此字段需要设置为空
    actImage: '', // 活动封面
    siteCodes: [], // 网点code列表
    _list: [],
    skuItems: [], // 活动图片
    groupNum: 0, // 拼团人数
    defDealHour: 24, // 默认成交时间,开启虚拟成交时使用
    productImages: [], // 拼团详情图片网址
    maxBuyerNum: 0, // 最大购买量 0表不限
    productName: '',
    pointsType: 1,
    type: 1,
    _qikanShow: true,
    _actShow: true,
    shareCardPicture: '',
    sharePicture: '',
    shippingState: 0,
  };

  // 是否开启佣金
  public isOpenCommission = 0;

  public rules = {
    ptName: [{ required: true, message: '请输入团购活动名称', trigger: 'change' }],
    siteCodes: [{ required: true, message: '请选择适用网点', trigger: 'change' }],
    actBeginTime: [{ required: true, message: '请选择团购活动期间', trigger: 'change' }],
    groupNum: [{ required: true, message: '请输入成团人数', trigger: 'change' }],
    defDealHour: [{ required: true, message: '请输入成团时限', trigger: 'change' }],
    _list: [{ required: true, message: '请选择活动商品', trigger: 'change' }],
    productImages: [{ required: true, message: '请选择团购描述', trigger: 'change' }],
    shareCardPicture: [{ required: true, message: '请选择分享卡片封面', trigger: 'change' }],
    sharePicture: [{ required: true, message: '请选择分享海报封面', trigger: 'change' }],
  };

  /**
   * 时间选择控制
   * @return null
   * @desc 当前时间控制到今天
   */
  public pickerOptions: ItemObject = {
    disabledDate(time) {
      const date = new Date();
      // return time.getTime() < date.getTime() - 3600*1000*24;
      return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
    },
  };

  /**
   * 错误图片
   */
  public errorImg: any = require('../../../../static/img/bg_pic.png');

  public uploadShareCardPictureSuccess(res: any): void {
    this.seckillForm.shareCardPicture = res.content;
    this.seckillForm.actImage = res.content;
  }

  public uploadSharePictureSuccess(res: any): void {
    this.seckillForm.sharePicture = res.content;
    this.seckillForm.qikanImage = res.content;
  }

  onDeletePic(key) {
    this.seckillForm[key] = '';
  }

  onMagnifyPic(key) {
    ImgPreview.open({ img: this.seckillForm[key] }).then(noop, noop);
  }

  /**
   * 新增适用网点
   * @return null
   */
  public onAddSite(readonly): void {
		new NewSelectSite()
      .open({
        service: 'authTree',
        selectCodes: this.seckillForm.siteCodes || [],
        readonly,
      })
      .then((res) => {
        this.seckillForm.siteCodes = res;
      }, noop);
  }

  /**
   * 活动封面上传成功时的处理
   * @return null
   */
  public uploadActivityPicSuccess(res: any): void {
    this.seckillForm.productImages = res;
  }

  public onActiveImgDelete(res) {
    this.seckillForm.productImages = res;
  }

  /**
   * 图片上传失败
   * @return null
   */
  public uploadImgError(): void {
    this.$message.error('图片上传失败');
  }

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 1024;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 1M!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 图片上传成功时的处理
   */
  public uploadImgSuccess(res) {
    this.addRang.insertEmbed(this.addRang.getSelection().index, 'image', res.content);
    // 调整光标位置
    this.addRang.getSelection(this.addRang.getSelection().index + 1);
  }

  /**
   * 获取秒杀活动详情
   * @return null
   */
  public getSecKillDetail(): void {
    this.finalSiteList = [];
    const postParams = {
      ptId: Number.parseInt(this.$route.params.id),
    };

    IPSService.getAssembleAct({ postParams }).then((res: any) => {
      const reslut = res.result;
      const listItem: any = {};
      const productKeys = ['productCode', 'productName', 'colorItems', 'sizeItems', 'skuItems', 'productOriginPrice', 'productImage', 'maxBuyerNum', 'isOpenCommission'];

      productKeys.forEach((i) => {
        listItem[i] = reslut[i];
        delete reslut[i];
      });

      listItem.productImages = reslut.productImages;

      reslut._list = [listItem];

      reslut.siteCodes = reslut.siteList.map(i => i.siteCode);

      delete reslut.siteList;

      reslut.actBeginTime = reslut.actBeginTime * 1000;
      reslut.actEndTime = reslut.actEndTime * 1000;

      // 处理展示配置
      if (reslut.qikanImage) {
        reslut._qikanShow = true;
      }
      if (reslut.actImage) {
        reslut._actShow = true;
      }

      this.seckillForm = reslut;
      // 设置状态
      this.state = reslut.state;
      this.activityState = reslut.activityState;
      this.seckillForm.goodsPrice = '';
      this.updatePersonCode = reslut.updatePersonCode;
      this.operAuthority = reslut.operAuthority;
    });
  }

  /**
   * 获取商品信息
   * @return null
   */
  public onGetProductInfo(): void {
    selectGoods.open({ multiple: false, showBD: false }).then((res) => {
      this.selectGoodsType = res.type;
      this.seckillForm._list = res.list;
      this.seckillForm.productImages = res.list[0].productImages;
    });
  }

  public beforeConfirm() {
    let seckillFormData = JSON.parse(JSON.stringify(this.seckillForm));
    let flag = false;
    seckillFormData._list && (flag = seckillFormData._list.every(this.validateIsEdit));
    if (flag) {
      this.$message.warning('当前页面存在未保存数据，请保存后再发布!');
      return false;
    }
    // 格式化数据
    seckillFormData.actBeginTime = moment(seckillFormData.actBeginTime).unix();
    seckillFormData.actEndTime = moment(seckillFormData.actEndTime).unix();

    // 处理展示配置
    if (!seckillFormData._qikanShow) {
      seckillFormData.qikanImage = '';
    }
    if (!seckillFormData._actShow) {
      seckillFormData.actImage = '';
    }
    // 商品的数据处理
    seckillFormData = validateParams({ ...seckillFormData, ...seckillFormData._list[0] });

    delete seckillFormData.productImage;

    return seckillFormData;
  }

  /**
   * 新增/编辑秒杀活动
   * @return null
   */
  public onSaveSeckillConfig(): void {
    const postParams = this.beforeConfirm();
    postParams.isOpenCommission = Number(postParams.isOpenCommission);
    if (!postParams) {
      return;
    }
    this.$refs.form.validate((flag) => {
      if (flag) {
        // 单独的图片判断
        if (postParams._actShow && !postParams.actImage) {
          this.$message.error('请选择图片');
          return;
        }
        if (postParams._qikanShow && !postParams.qikanImage) {
          this.$message.error('请选择图片');
          return;
        }

        const loading = this.$loading({
          lock: true,
          text: '请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(225,225,225,0.3)',
        });

        IPSService.editAssembleAct({ postParams })
          .then((res) => {
            if (res) {
              this.$message.success('保存成功');
              loading.close();
              this.goBack();
            } else {
              loading.close();
            }
          })
          .catch(() => {
            loading.close();
          });
      }
    });
  }

  /**
   * 返回列表页
   * @return null
   */
  public goBack(): void {
    this.$router.go(-1);
  }

  /**
   * 二维码预览
   */
  public getWxCode(): void {
    const postParams = this.beforeConfirm();
    this.$refs.form.validate((flag) => {
      if (flag) {
        IPSService.getPtActPreviewCode({ postParams }).then((responseData) => {
          if (responseData && responseData.ptWxUrl) {
            this.imageView = responseData.ptWxUrl;
            this.isShowCode = true;
          }
        });
      }
    });
  }

  /**
   * 关闭预览
   * @return null
   */
  public closePreviewWindow(): void {
    this.isShowCode = false;
  }

  public mounted(): void {
    const id = this.$route.params.id;
    this.platformVersion = +localStorage.getItem('platformVersion');
    if (+id) {
      this.getSecKillDetail(); // 获取拼团详情
    }
  }

  /**
   * 验证是否有编辑完未保存的商品
   */
  public validateIsEdit(val) {
    return val._edit === true;
  }
}
